import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';

const ContactInformationTab = ({selectedBusiness }) => {
  const [formData, setFormData] = useState({
    primaryPhone: '(555) 123-4567',
    secondaryPhone: '(555) 123-4568',
    email: 'info@elitecarwash.com',
    website: 'https://www.elitecarwash.com',
    socialMedia: {
      facebook: 'https://facebook.com/elitecarwash',
      instagram: 'https://instagram.com/elitecarwash',
      twitter: 'https://twitter.com/elitecarwash',
      linkedin: ''
    },
    emergencyContact: {
      name: 'John Smith',
      phone: '(555) 987-6543',
      relationship: 'Manager'
    }
  });

  const [hasChanges, setHasChanges] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const handleInputChange = (field, value) => {
    if (field?.includes('.')) {
      const [parent, child] = field?.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev?.[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
    setHasChanges(true);
    
    // Clear validation error for this field
    if (validationErrors?.[field]) {
      setValidationErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData?.email && !emailRegex?.test(formData?.email)) {
      errors.email = 'Please enter a valid email address';
    }
    
    // Phone validation
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    if (formData?.primaryPhone && !phoneRegex?.test(formData?.primaryPhone)) {
      errors.primaryPhone = 'Please enter phone in format: (555) 123-4567';
    }
    
    // Website validation
    const urlRegex = /^https?:\/\/.+\..+/;
    if (formData?.website && !urlRegex?.test(formData?.website)) {
      errors.website = 'Please enter a valid website URL';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSave = () => {
    if (validateForm()) {
   
      setHasChanges(false);
    }
  };

  const formatPhoneNumber = (value) => {
    const numbers = value?.replace(/\D/g, '');
    if (numbers?.length >= 10) {
      return `(${numbers?.slice(0, 3)}) ${numbers?.slice(3, 6)}-${numbers?.slice(6, 10)}`;
    }
    return value;
  };

  const handlePhoneChange = (field, value) => {
    const formatted = formatPhoneNumber(value);
    handleInputChange(field, formatted);
  };

  const socialMediaPlatforms = [
    { key: 'facebook', label: 'Facebook', icon: 'Facebook', placeholder: 'https://facebook.com/yourbusiness' },
    { key: 'instagram', label: 'Instagram', icon: 'Instagram', placeholder: 'https://instagram.com/yourbusiness' },
    { key: 'twitter', label: 'Twitter', icon: 'Twitter', placeholder: 'https://twitter.com/yourbusiness' },
    { key: 'linkedin', label: 'LinkedIn', icon: 'Linkedin', placeholder: 'https://linkedin.com/company/yourbusiness' }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Social Media Information</h3>
          <p className="text-sm text-muted-foreground">
            Manage your business social media presence
          </p>
        </div>
        {hasChanges && (
          <div className="flex items-center space-x-2">
            <div className="status-indicator warning"></div>
            <span className="text-sm text-warning">Unsaved changes</span>
          </div>
        )}
      </div>
      {/* Primary Contact Information */}
      <div className="bg-card border border-border rounded-lg p-6">
        {/* <h4 className="text-md font-medium text-foreground mb-4">Primary Contact</h4>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Input
            label="Primary Phone"
            type="tel"
            placeholder="(555) 123-4567"
            value={formData?.primaryPhone}
            onChange={(e) => handlePhoneChange('primaryPhone', e?.target?.value)}
            error={validationErrors?.primaryPhone}
            required
          />

          <Input
            label="Secondary Phone"
            type="tel"
            placeholder="(555) 123-4568"
            value={formData?.secondaryPhone}
            onChange={(e) => handlePhoneChange('secondaryPhone', e?.target?.value)}
            description="Optional backup contact number"
          />

          <Input
            label="Email Address"
            type="email"
            placeholder="info@yourbusiness.com"
            value={formData?.email}
            onChange={(e) => handleInputChange('email', e?.target?.value)}
            error={validationErrors?.email}
            required
          />

          <Input
            label="Website URL"
            type="url"
            placeholder="https://www.yourbusiness.com"
            value={formData?.website}
            onChange={(e) => handleInputChange('website', e?.target?.value)}
            error={validationErrors?.website}
          />
        </div> */}
        <div className="flex items-center justify-center">
          <h3 className=''>Coming soon...</h3>
        </div>
      </div>
      {/* Social Media Links */}
      {/* <div className="bg-card border border-border rounded-lg p-6">
        <h4 className="text-md font-medium text-foreground mb-4">Social Media Presence</h4>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {socialMediaPlatforms?.map((platform) => (
            <div key={platform?.key} className="flex items-center space-x-3">
              <div className="flex-shrink-0 w-10 h-10 bg-muted rounded-lg flex items-center justify-center">
                <Icon name={platform?.icon} size={20} className="text-muted-foreground" />
              </div>
              <div className="flex-1">
                <Input
                  label={platform?.label}
                  type="url"
                  placeholder={platform?.placeholder}
                  value={formData?.socialMedia?.[platform?.key]}
                  onChange={(e) => handleInputChange(`socialMedia.${platform?.key}`, e?.target?.value)}
                />
              </div>
            </div>
          ))}
        </div>
      </div> */}
      {/* Emergency Contact */}
      {/* <div className="bg-card border border-border rounded-lg p-6">
        <h4 className="text-md font-medium text-foreground mb-4">Emergency Contact</h4>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <Input
            label="Contact Name"
            type="text"
            placeholder="Enter contact name"
            value={formData?.emergencyContact?.name}
            onChange={(e) => handleInputChange('emergencyContact.name', e?.target?.value)}
            required
          />

          <Input
            label="Contact Phone"
            type="tel"
            placeholder="(555) 987-6543"
            value={formData?.emergencyContact?.phone}
            onChange={(e) => handlePhoneChange('emergencyContact.phone', e?.target?.value)}
            required
          />

          <Input
            label="Relationship"
            type="text"
            placeholder="Manager, Owner, etc."
            value={formData?.emergencyContact?.relationship}
            onChange={(e) => handleInputChange('emergencyContact.relationship', e?.target?.value)}
          />
        </div>
      </div> */}
      {/* Contact Preferences */}
      {/* <div className="bg-card border border-border rounded-lg p-6">
        <h4 className="text-md font-medium text-foreground mb-4">Contact Preferences</h4>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h5 className="text-sm font-medium text-foreground">Preferred Contact Methods</h5>
            <div className="space-y-2">
              <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
                <Icon name="Phone" size={16} className="text-primary" />
                <span className="text-sm text-foreground">Phone calls during business hours</span>
              </div>
              <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
                <Icon name="Mail" size={16} className="text-primary" />
                <span className="text-sm text-foreground">Email for non-urgent matters</span>
              </div>
              <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
                <Icon name="MessageSquare" size={16} className="text-primary" />
                <span className="text-sm text-foreground">Text messages for appointments</span>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h5 className="text-sm font-medium text-foreground">Response Times</h5>
            <div className="space-y-2">
              <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                <span className="text-sm text-foreground">Phone calls</span>
                <span className="text-sm font-medium text-primary">Immediate</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                <span className="text-sm text-foreground">Emails</span>
                <span className="text-sm font-medium text-primary">Within 2 hours</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                <span className="text-sm text-foreground">Social media</span>
                <span className="text-sm font-medium text-primary">Within 4 hours</span>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* Action Buttons */}
      {/* <div className="flex items-center justify-end pt-4 border-t border-border">
        <Button
          variant="default"
          onClick={handleSave}
          disabled={!hasChanges}
          loading={isLoading}
          iconName="Save"
          iconPosition="left"
          iconSize={16}
        >
          Save Changes
        </Button>
      </div> */}
    </div>
  );
};

export default ContactInformationTab;